import { CanvasserType } from '@signalvote/shared';

interface CanvasserTypeBadgeProps {
  type: CanvasserType | null | undefined;
}

export function CanvasserTypeBadge({ type }: CanvasserTypeBadgeProps) {
  if (!type) return null;

  const isPaid = type === CanvasserType.Paid;

  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${
        isPaid ? 'bg-orange-100 text-orange-700' : 'bg-blue-100 text-blue-700'
      }`}
    >
      {type}
    </span>
  );
}
